var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStaff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "69px",
    height: "69px",
    viewBox: "0 0 69 69",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-\u5458\u5DE5\u6570") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-18.000000, -385.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-\\u5458\\u5DE5\\u6570",
    transform: "translate(18.000000, 385.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "\\u591A\\u8FB9\\u5F62",
    fillOpacity: 0.122809563,
    fill: "#FFFFFF",
    points: "34.5 0 64.3778764 17.25 64.3778764 51.75 34.5 69 4.62212357 51.75 4.62212357 17.25"
  }), /*#__PURE__*/React.createElement("g", {
    id: "contacts-outlined",
    transform: "translate(15.000000, 14.000000)",
    fill: "#15E3FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    opacity: 0,
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2148437,23.4960938 C23.921875,22.71875 24.3515625,21.6835938 24.3515625,20.546875 C24.3515625,18.1289062 22.4023438,16.171875 20,16.171875 C17.5976562,16.171875 15.6484375,18.1289062 15.6484375,20.546875 C15.6484375,21.6835938 16.078125,22.7148438 16.7851563,23.4960938 C15.1171875,24.53125 13.9804688,26.3398438 13.8710938,28.421875 C13.8632813,28.6015625 14.0039063,28.75 14.1835938,28.75 L15.8984375,28.75 C16.0625,28.75 16.1953125,28.6210938 16.2070312,28.4570312 C16.3554688,26.4804688 18.0039062,24.921875 20.0039062,24.921875 C22.0039062,24.921875 23.6523438,26.484375 23.8007812,28.4570312 C23.8125,28.6210938 23.9453125,28.75 24.109375,28.75 L25.8203125,28.75 C26,28.75 26.140625,28.6015625 26.1328125,28.421875 C26.0234375,26.3398438 24.8828125,24.5273438 23.2148437,23.4960938 Z M20,22.578125 C18.8867188,22.578125 17.9804688,21.6679688 17.9804688,20.546875 C17.9804688,19.4257812 18.8867188,18.515625 20,18.515625 C21.1132812,18.515625 22.0195312,19.4257812 22.0195312,20.546875 C22.0195312,21.6679688 21.1132812,22.578125 20,22.578125 Z M36.25,8.75 L30,8.75 L30,6.5625 C30,6.390625 29.859375,6.25 29.6875,6.25 L27.5,6.25 C27.328125,6.25 27.1875,6.390625 27.1875,6.5625 L27.1875,8.75 L21.40625,8.75 L21.40625,6.5625 C21.40625,6.390625 21.265625,6.25 21.09375,6.25 L18.90625,6.25 C18.734375,6.25 18.59375,6.390625 18.59375,6.5625 L18.59375,8.75 L12.8125,8.75 L12.8125,6.5625 C12.8125,6.390625 12.671875,6.25 12.5,6.25 L10.3125,6.25 C10.140625,6.25 10,6.390625 10,6.5625 L10,8.75 L3.75,8.75 C3.05859375,8.75 2.5,9.30859375 2.5,10 L2.5,32.5 C2.5,33.1914062 3.05859375,33.75 3.75,33.75 L36.25,33.75 C36.9414062,33.75 37.5,33.1914062 37.5,32.5 L37.5,10 C37.5,9.30859375 36.9414062,8.75 36.25,8.75 Z M34.6875,30.9375 L5.3125,30.9375 L5.3125,11.5625 L10,11.5625 L10,13.75 C10,13.921875 10.140625,14.0625 10.3125,14.0625 L12.5,14.0625 C12.671875,14.0625 12.8125,13.921875 12.8125,13.75 L12.8125,11.5625 L18.59375,11.5625 L18.59375,13.75 C18.59375,13.921875 18.734375,14.0625 18.90625,14.0625 L21.09375,14.0625 C21.265625,14.0625 21.40625,13.921875 21.40625,13.75 L21.40625,11.5625 L27.1875,11.5625 L27.1875,13.75 C27.1875,13.921875 27.328125,14.0625 27.5,14.0625 L29.6875,14.0625 C29.859375,14.0625 30,13.921875 30,13.75 L30,11.5625 L34.6875,11.5625 L34.6875,30.9375 Z",
    id: "\\u5F62\\u72B6"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff);
export default __webpack_public_path__ + "static/media/staff.7ff6184faa6c2efc2efc3e11acbc039c.svg";
export { ForwardRef as ReactComponent };